import { render, staticRenderFns } from "./AssignCard.vue?vue&type=template&id=88664e3c&scoped=true&"
import script from "./AssignCard.vue?vue&type=script&lang=js&"
export * from "./AssignCard.vue?vue&type=script&lang=js&"
import style0 from "./AssignCard.vue?vue&type=style&index=0&id=88664e3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88664e3c",
  null
  
)

export default component.exports